import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { getEvents, deleteAnEvent, resetState } from "../features/events/eventSlice"; // updated to events
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "title",
    sorter: (a, b) => a.title.length - b.title.length,
    width: 300,
  },
  {
    title: "Speaker", 
    dataIndex: "speaker",
    sorter: (a, b) => a.speaker.length - b.speaker.length,
  },
  {
    title: "Start Date", 
    dataIndex: "startDate",
    sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const EventList = () => {
  const [open, setOpen] = useState(false);
  const [eventId, setEventId] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetState());
    dispatch(getEvents());
  }, [dispatch]);

  const eventState = useSelector((state) => state.events.events);

  const showModal = (id) => {
    setOpen(true);
    setEventId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const handleDeleteEvent = (id) => {
    dispatch(deleteAnEvent(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getEvents());
    }, 100);
  };

  const data = [];
  for (let i = 0; i < eventState.length; i++) {
    data.push({
      key: i + 1,
      title: eventState[i].title,
      speaker: eventState[i].speaker,
      startDate: new Date(eventState[i].startDate).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
      action: (
        <>
          <Link to={`/admin/event/${eventState[i]._id}`} className="fs-3 text-danger">
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(eventState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }

  return (
    <div>
      <h3 className="mb-4 title">Events</h3>
      <div>
        <Table columns={columns} dataSource={data} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => handleDeleteEvent(eventId)}
        title="Are you sure you want to delete this event?"
      />
    </div>
  );
};

export default EventList;
